export const formatDateString = (date: Date) => date.toISOString();

export const getSentDate = () => new Date();
